import type { FC, PropsWithChildren } from "react";
import React from "react";

import { ButtonInline } from "../../../../ButtonInline";
import { createDisplayNameForHeaderShowAll } from "../../utils/createDisplayName";
import { createTestIdForHeaderShowAll } from "../../utils/createTestId";

import type {
    HeaderRightButtonProps,
    ICoreHeaderTextView,
} from "../../../general/CoreHeader/types";

const RIGHT_BUTTON_INLINE_TEST_ID = createTestIdForHeaderShowAll(
    "right-button-inline",
);

interface IHeaderShowAllRightButtonInline
    extends PropsWithChildren<HeaderRightButtonProps> {}

export const HeaderShowAllRightButtonInline: FC<
    IHeaderShowAllRightButtonInline
> = (props) => {
    const {
        view,
        children,
        "data-tsid": tsid = RIGHT_BUTTON_INLINE_TEST_ID,
        ...restProps
    } = props as IHeaderShowAllRightButtonInline & ICoreHeaderTextView;

    return (
        <ButtonInline {...restProps} size="24" view={view} data-tsid={tsid}>
            <ButtonInline.Label>{children}</ButtonInline.Label>
        </ButtonInline>
    );
};

HeaderShowAllRightButtonInline.displayName =
    createDisplayNameForHeaderShowAll("RightButtonInline");

export default HeaderShowAllRightButtonInline;
